import React from 'react';
import { Box, Flex, Text, VStack } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import colors from '../../styles/theme/foundation/colors';

function NoResultsMessage({ dusk, image, message, altTag, subText }) {
  return (
    <Box dusk={dusk} height="400px" w="100%">
      <Flex align="center" direction="column" h="100%" justify="space-evenly" mt={10} w="100%">
        <img alt={altTag} src={image} />
        <VStack>
          <Text color={colors.greyScale['500']} textStyle="displayXxs">
            {message}
          </Text>
          <Text color={colors.greyScale['500']} textStyle="bodyLg500">
            {subText}
          </Text>
        </VStack>
      </Flex>
    </Box>
  );
}

NoResultsMessage.propTypes = {
  image: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  altTag: PropTypes.string.isRequired,
  subText: PropTypes.string
};

export default NoResultsMessage;
